module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "bg-pic"
  }, [_c('img', {
    staticClass: "lazy",
    attrs: {
      "src": require("assets/img/bg-buildings.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-caption pull-bottom sm-pull-bottom text-white p-l-20 m-b-20"
  }, [_c('h2', {
    staticClass: "semi-bold text-white",
    domProps: {
      "innerHTML": _vm._s(_vm.slogan)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("\n        All Rights Reserved. © 2018 "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.brand)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "login-container bg-white"
  }, [_c('div', {
    staticClass: "p-l-50 m-l-20 p-r-50 m-r-20 p-t-50 m-t-30 sm-p-l-15 sm-p-r-15 sm-p-t-40"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', {
    staticClass: "p-t-35"
  }, [_vm._v("Sign into your "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.brand)
    }
  }), _vm._v(" account")]), _vm._v(" "), _c('form', {
    staticClass: "p-t-15",
    attrs: {
      "id": "form-login",
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit()
      }
    }
  }, [_c('pg-input', {
    ref: "email",
    attrs: {
      "initialValue": _vm.email,
      "label": "Login",
      "name": "email",
      "placehodler": "Email",
      "validations": "required|email"
    }
  }), _vm._v(" "), _c('pg-input', {
    ref: "password",
    attrs: {
      "initialValue": _vm.password,
      "type": "password",
      "label": "Password",
      "name": "password",
      "placehodler": "Password",
      "validations": "required"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 no-padding"
  }, [_c('pg-checkbox', {
    attrs: {
      "label": "Keep Me Signed In",
      "value": true
    }
  })], 1), _vm._v(" "), _vm._m(1, false, false)]), _vm._v(" "), _c('pg-button', {
    attrs: {
      "submit": "",
      "cls": "m-t-15"
    },
    nativeOn: {
      "click": function($event) {
        _vm.validateBeforeSubmit()
      }
    }
  }, [_vm._v("Sign in")])], 1), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/img/logo_dark.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 text-right hide"
  }, [_c('a', {
    staticClass: "text-info small",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Help? Contact Support")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-bottom sm-pull-bottom"
  }, [_c('div', {
    staticClass: "m-b-30 p-r-80 sm-m-t-20 sm-p-r-15 sm-p-b-20 clearfix"
  }, [_c('div', {
    staticClass: "col-sm-9 no-padding m-t-10"
  }, [_c('p', [_c('small', [_vm._v("\n              If you have any questions or need help, please contact "), _c('a', {
    staticClass: "text-info",
    attrs: {
      "href": ""
    }
  }, [_vm._v("our support")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5085f7b6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 1249
// module chunks = 1